import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconChevronLeft = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.4142 12.0001L14.7071 8.70718L13.2929 7.29297L9.29289 11.293C8.90237 11.6835 8.90237 12.3167 9.29289 12.7072L13.2929 16.7072L14.7071 15.293L11.4142 12.0001Z"
        />
      </svg>
    );
  }
);
